<template>
  <b-form @submit.prevent="onSubmit" novalidate class="label-bold" autocomplete="off">
    <b-tabs v-model="tabIndex" content-class="mt-4">
      <b-tab title="Profile">
        <b-form-group class="text-center">
          <avatar :src="profilePhoto" size="9rem" />
          <input ref="photoFile" type="file" name="avatar" accept="image/*" @change="onPhotoSelect" hidden />
          <b-button
            variant="link"
            class="btn-link-primary"
            v-b-tooltip.hover
            title="Min. 400x400 px. Format: jpg, png or gif. Max. size file is 2MB"
            @click="onPhotoEditClick"
          >
            Edit
          </b-button>
          <b-form-invalid-feedback :state="isValidField('photo')">
            <div v-for="error in errors.photo || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-first-name" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            First Name
          </template>
          <b-form-input id="input-first-name" v-model="form.firstName" :state="isValidField('firstName')" placeholder="First Name" />
          <b-form-invalid-feedback :state="isValidField('firstName')">
            <div v-for="error in errors.firstName || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-last-name" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Last Name
          </template>
          <b-form-input id="input-last-name" v-model="form.lastName" :state="isValidField('lastName')" placeholder="Last Name" />
          <b-form-invalid-feedback :state="isValidField('lastName')">
            <div v-for="error in errors.lastName || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-nickname" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Preferred Name
          </template>
          <b-form-input id="input-nickname" v-model="form.nickname" :state="isValidField('nickname')" placeholder="eg., Ericka" />
          <b-form-invalid-feedback :state="isValidField('nickname')">
            <div v-for="error in errors.nickname || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-pronoun" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Pronoun
          </template>
          <b-form-select id="input-pronoun" v-model="form.pronoun" :state="isValidField('pronoun')" placeholder="Select pronoun...">
            <b-form-select-option
              v-for="option in pronounOptions"
              :key="option.value || 'empty'"
              :value="option.value">
              {{option.text}}
            </b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback :state="isValidField('pronoun')">
            <div v-for="error in errors.pronoun || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-title" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Title
          </template>
          <b-form-input id="input-title" v-model="form.title" :state="isValidField('title')" placeholder="Senior HR Specialist" />
          <b-form-invalid-feedback :state="isValidField('title')">
            <div v-for="error in errors.title || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-department" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Department
          </template>
          <b-form-input id="input-department" v-model="form.department" :state="isValidField('department')" placeholder="Human Resources" />
          <b-form-invalid-feedback :state="isValidField('department')">
            <div v-for="error in errors.department || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-service" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Service
          </template>
          <b-form-input id="input-service" v-model="form.service" :state="isValidField('service')" placeholder="Support" />
          <b-form-invalid-feedback :state="isValidField('service')">
            <div v-for="error in errors.service || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-office-location" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Office Location
          </template>
          <b-form-input id="input-office-location" v-model="form.officeLocation" :state="isValidField('officeLocation')" placeholder="San Francisco" />
          <b-form-invalid-feedback :state="isValidField('officeLocation')">
            <div v-for="error in errors.officeLocation || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-tab>

      <b-tab title="About Me">
        <b-form-group label-for="input-city-address" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            I'm from
          </template>
          <b-form-input id="input-city-address" v-model="form.cityAddress" :state="isValidField('cityAddress')" placeholder="San Jose, California" />
          <b-form-invalid-feedback :state="isValidField('cityAddress')">
            <div v-for="error in errors.cityAddress || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-facts" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Facts about me
          </template>
          <b-form-textarea id="input-facts" v-model="form.facts" rows="4" :state="isValidField('facts')" placeholder="I am a big Giant's fan. I have 2 kids and I love cooking" />
          <b-form-invalid-feedback :state="isValidField('facts')">
            <div v-for="error in errors.facts || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-show-birthday" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Show birthday icon?
          </template>
          <toggle-button
            v-model="form.showBirthdayIcon"
            :labels="{ checked: 'Yes', unchecked: 'No' }"
            color="#AD198C"
            :width="70"
            :height="30"
            :font-size="15"
          />
          <b-form-text class="font-italic">You’ll have an icon next to your name in your profile page</b-form-text>
        </b-form-group>
        <b-form-group label-for="input-inspiration-image" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Inspiration board
          </template>
          <b-img :src="computedInspirationImage" :style="{maxHeight: '200px'}" fluid />
          <input ref="inspirationFile" type="file" name="avatar" accept="image/*" @change="onInspirationSelect" hidden />
          <b-form-invalid-feedback :state="isValidField('inspirationImage')">
            <div v-for="error in errors.inspirationImage || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
          <div>
            <b-button variant="link" class="p-0 mt-2" @click="onInspirationEditClick">
              Edit
            </b-button>
          </div>
        </b-form-group>
        <b-form-group label-for="input-skills" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            A skill I can offer
          </template>
          <b-form-tags id="input-skills" v-model="form.skills" :state="isValidField('skills')" separator="," />
          <b-form-invalid-feedback :state="isValidField('skills')">
            <div v-for="error in errors.skills || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-values" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            What I value
          </template>
          <b-form-input id="input-values" v-model="form.values" :state="isValidField('values')" placeholder="e.g.: Integrity, having a good time with colleagues" />
          <b-form-invalid-feedback :state="isValidField('values')">
            <div v-for="error in errors.values || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-motivations" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Key Motivations
          </template>
          <b-form-input
            id="input-motivations"
            v-model="form.motivations"
            :state="isValidField('motivations')"
            placeholder="e.g.: Growth opportunities, Challenges, becoming an expert, Being an inspiring leader..."
          />
          <b-form-invalid-feedback :state="isValidField('motivations')">
            <div v-for="error in errors.motivations || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-professional-future" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Professional future
          </template>
          <b-form-select id="input-professional-future" v-model="professionalFuture">
            <b-form-select-option value="short">Short term (one year)</b-form-select-option>
            <b-form-select-option value="mid">Mid term (three year)</b-form-select-option>
            <b-form-select-option value="long">Long term (five year)</b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group label-cols-sm="4" label-cols-lg="3">
          <b-textarea v-if="professionalFuture==='short'" v-model="form.shortTermGoals" rows="4" />
          <b-textarea v-else-if="professionalFuture==='mid'" v-model="form.midTermGoals" rows="4" />
          <b-textarea v-else-if="professionalFuture==='long'" v-model="form.longTermGoals" rows="4" />
        </b-form-group>
      </b-tab>

      <b-tab title="Contact info">
        <b-form-group label-for="input-phone" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Phone
          </template>
          <b-form-input id="input-phone" v-model="form.phone" :state="isValidField('phone')" placeholder="(115-768-973)" />
          <b-form-invalid-feedback :state="isValidField('phone')">
            <div v-for="error in errors.phone || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-channels" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Best way to reach me
          </template>
          <channels v-model="form" size="1.7rem" selectable />
        </b-form-group>
        <b-form-group label-for="input-best-time" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Best time to catch me
          </template>
          <b-form-input
            id="input-best-time"
            v-model="form.bestTime"
            :state="isValidField('bestTime')"
            placeholder="e.g.: during lunch break, from 10am to 12am, Wed-Thurs., ..."
          />
          <b-form-invalid-feedback :state="isValidField('bestTime')">
            <div v-for="error in errors.bestTime || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-for="input-timezone" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            My timezone
          </template>
          <timezone-input id="input-timezone" v-model="form.timezone" :state="isValidField('timezone')" :with-empty="true" />
          <b-form-invalid-feedback :state="isValidField('timezone')">
            <div v-for="error in errors.timezone || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-tab>

      <b-tab title="Account">
        <b-form-group label-for="input-email" label-cols-sm="4" label-cols-lg="3">
          <template #label>
            Email
          </template>
          <b-form-input id="input-email" type="email" v-model="form.email" :state="isValidField('email')"  />
          <b-form-invalid-feedback :state="isValidField('email')">
            <div v-for="error in errors.email || []" :key="error">
              {{ error }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <change-password-form :state="changePasswordState" :submitting="submitting" @submit="$emit('change-password', $event)" />
      </b-tab>
    </b-tabs>
    <b-form-row class="justify-content-end mt-5">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Update Profile</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'
import ChangePasswordForm from './ChangePasswordForm.vue'
import Channels from '@/components/common/Channels'
import TimezoneInput from '@/components/common/TimezoneInput'
import Avatar from '@/components/common/Avatar'
import { PronounOptions, toFormData, readFile } from '@/helpers/helpers'
import { INSPIRATION_DEFAULT } from '@/helpers/constants'

export default {
  name: 'EditUserProfileForm',

  mixins: [MixinForm],

  props: {
    profile: {
      type: Object,
      default: () => ({})
    },

    activeTab: {
      type: Number,
      default: 0
    },

    changePasswordState: [Object, String]
  },

  watch: {
    profile(value) {
      const { inspirationImage, photo, ...other } = value
      this.form = this.init(other)
      this.inspirationImage = inspirationImage
      this.profilePhoto = photo
    },

    activeTab(value) {
      this.tabIndex = value
    }
  },

  data() {
    const { inspirationImage, photo, ...other } = this.profile
    const data = this.init(other)

    return {
      form: data,
      profilePhoto: photo,
      inspirationImage: inspirationImage,
      tabIndex: this.activeTab,
      pronounOptions: [{ value: '', text: '-' }, ...PronounOptions],
      professionalFuture: 'short'
    }
  },

  computed: {
    computedInspirationImage() {
      return this.inspirationImage || INSPIRATION_DEFAULT
    }
  },

  methods: {
    init(profile) {
      return {
        ...profile,
        skills: (profile.skills || '').split(',').map(p => p.trim()).filter(Boolean)
      }
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.firstName || '')) errors.firstName = ["First Name can't be blank"]
      if (validator.isEmpty(data.lastName || '')) errors.lastName = ["Last Name can't be blank"]
      if (!data.email || !validator.isEmail(data.email || '')) errors.email = ['Email is invalid']
      if (data.photo && data.photo.size > 2097152) errors.photo = ['Invalid photo']
      return errors
    },

    prepare(data) {
      return toFormData({ ...data, skills: data.skills.join(',') })
    },

    onPhotoSelect({ target }) {
      readFile(target.files[0], event => {
        this.profilePhoto = event.target.result
      })
      this.form.photo = target.files[0]
    },

    onPhotoEditClick() {
      this.$refs.photoFile.click()
    },

    onInspirationSelect({ target }) {
      readFile(target.files[0], event => {
        this.inspirationImage = event.target.result
      })
      this.form.inspirationImage = target.files[0]
    },

    onInspirationEditClick() {
      this.$refs.inspirationFile.click()
    }
  },

  components: {
    Channels,
    TimezoneInput,
    Avatar,
    ChangePasswordForm
  }
}
</script>
